import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { DeleteForm } from '../mutations/deleteForm.mutation';
import type { DeleteFormMutation, DeleteFormMutationVariables } from '../types';

export const useDeleteFormMutation = (
  options?: MutationOptions<DeleteFormMutation, DeleteFormMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteForm), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('form') || query.queryKey.includes('forms'),
      });
    },
  });
};
